import * as Actions from '../actions';
export const addToCart = (data) => {
  // DATA IS PRODUCT DETAIL
  return (dispatch) => {
    dispatch({ type: Actions.ADD_CART, payload: data });
  };
};

export const removeFromCart = (data) => {
  // DATA IS ID
  return (dispatch) => {
    dispatch({ type: Actions.REMOVE_PRODUCT, payload: data.id });
    dispatch({
      type: Actions.CREATE_ERROR,
      payload: { msg:  `${data.title} removed from cart`, type: 'success' },
    });
  };
};
